export interface CheckoutCustomerTelephoneDetails {
  Home?: string | null;
  other?: string | null;
  work?: string | null;
}
